import { render, staticRenderFns } from "./QuickNote.vue?vue&type=template&id=b7f34418&"
import script from "./QuickNote.vue?vue&type=script&lang=js&"
export * from "./QuickNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports